import { IDeleteTermoUseCase } from "../../../presentation/useCases/delete/delete_termo_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteTermoUseCase
 */

export class DeleteTermoUseCase implements IDeleteTermoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idTermo: number): Promise<void> {
    await this.repository.deleteTermoById(idTermo);

  }
}
